import { baseStatusOptions } from 'constants/options';
import { ItemGroupAlignment, ItemLabelPlacement } from 'constants/ui';

import {
  additionalContentInputStyles,
  getAdditionalContentStyles,
  getCheckboxesGroupStyles,
  radioListStyles,
} from './Declarations.styles';

export const defaultRadioInputProps = {
  disabled: false,
  required: false,
  options: baseStatusOptions,
  align: ItemGroupAlignment.HORIZONTAL,
  labelPlacement: ItemLabelPlacement.END,
  customStyles: radioListStyles,
};

export const getDefaultCheckboxesGroupProps = ({
  padding,
  checkboxesPadding,
  withBottomBorder,
} = {}) => ({
  disabled: false,
  required: false,
  labelPlacement: ItemLabelPlacement.END,
  customStyles: getCheckboxesGroupStyles({ padding, checkboxesPadding, withBottomBorder }),
});

export const getAdditionalContentProps = withBottomBorder => ({
  width: '30%',
  additionalContainerProps: {
    className: 'flex w-full justify-between items-center',
    sx: getAdditionalContentStyles(withBottomBorder),
  },
  additionalTitleProps: {
    className: 'flex-1 additional-title',
  },
  customStyles: additionalContentInputStyles,
});

export const DeclarationType = {
  PROPERTY_AND_LOAN: 'propertyAndLoan',
  FINANCES: 'finances',
  MILITARY_SERVICES: 'militaryService',
  DEMOGRAPHIC_INFORMATION: 'demographicInformation',
  GENERAL_INFORMATION: 'general',
  COUNSELING: 'homeCounseling',
  HOMEOWNERSHIP_EDUCATION_AND_HOUSING_COUNSELING: 'homeownershipEducationAndHousingCounseling',
  LANGUAGE_PREFERENCE: 'languagePreference',
  SOURCE: 'source',
};

export const SEX_TYPE = 'sex';

export const firstTimeVaUseOptions = [
  { name: 'N/A', value: 'NA' },
  { name: 'Yes', value: 'Yes' },
  { name: 'No', value: 'No' },
];
